import formatePrice from '../../formatePrice'
import { getString } from '../../constants'

// template for small points
const pointMarker = marker => `
  <div id="marker-pointer-${marker.id}" class="marker point">
    <span class="pointer">&nbsp;</span>
    <div class="show-text">
      <span class="marker-name">${marker.name}</span>
      <span class="marker-price">${formatePrice(marker.price)}&nbsp;${getString('CURRENCY')}</span>
    </div>
  </div>
`

export default pointMarker



// WEBPACK FOOTER //
// ./app/utils/infoBox/templates/pointMarker.js